import { CommonBaseData } from "../shared/data/common-base-data";

export class N3026InputData extends CommonBaseData {
  // 帳票区分
  public chohyoKbn: string;
  // 出力区分_本体
  public shuturyokuKbn_hontai: boolean;
  // 出力区分_部材
  public shuturyokuKbn_buzai: boolean;

  // 配送時間個別仮登録画面のセッションストレージの値
  // 日付
  public hizukeKubun: string;
  public hizukeStart: string;
  public hizukeEnd: string;

  // ニチハ営業所　受注番号
  public nichihaEigyosho: string;
  public jyutyuBango: string;

  // 宛名　お客様注文No.
  public atena: string;
  public okyauksamaTyumonNo: string;

  // 配送形態　品番
  public haisouKeitai: string;
  public haisouKeitai1: string;
  public haisouKeitai2: string;
  public haisouKeitai3: string;
  public hinban: string;

  // 建築会社様名　登録状況
  public kenchikuKaisyaSamaMei: string;
  public tourokuJokyo: string;
  public tourokuJokyo1: string;
  public tourokuJokyo2: string;
  public tourokuJokyo3: string;

  // 物件名　配送ルート
  public bukenMei: string;
  public haisoRuto: string;

  // 出荷用備考　車番
  public syukayoBiko: string;
  public syaban: string;

  // 注文方法　並び順
  public chumonHoho: string;
  public chumonHoho1: string;
  public chumonHoho2: string;
  public narabiJyun: string;

  // 過去５営業日
  public kakoEigyoubi5: string;
  // FROMの１０営業日前
  public kakoEigyoubi10: string;

}



// WEBPACK FOOTER //
// ./src/app/modules/n302/n3026-input-data.ts